import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { Card } from './ui/card';
import { profileData, technicalSkills } from '../data/mock';

const About = () => {
  return (
    <section id="about" className="py-20 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Image */}
          <div className="order-2 lg:order-1">
            <div className="relative">
              <img
                src={profileData.aboutImage}
                alt="Professional expertise"
                className="rounded-2xl shadow-xl w-full h-auto object-cover"
              />
              <div className="absolute -bottom-6 -right-6 bg-amber-600 text-white p-8 rounded-xl shadow-lg">
                <div className="text-5xl font-bold mb-2">{profileData.experience}</div>
                <div className="text-lg font-medium">Experience</div>
              </div>
            </div>
          </div>

          {/* Right Content */}
          <div className="order-1 lg:order-2 space-y-6">
            <div>
              <p className="text-amber-600 font-semibold text-lg mb-2">About Me</p>
              <h2 className="text-4xl font-bold text-slate-800 mb-6">
                Senior Finance & Tax Professional
              </h2>
            </div>

            <p className="text-lg text-gray-700 leading-relaxed">
              A distinguished Chartered Accountant with comprehensive qualifications including Cost Accountant, 
              Insolvency Professional, and Law Graduate credentials from Delhi University.
            </p>

            <p className="text-lg text-gray-700 leading-relaxed">
              Specialized in Direct Tax, International Taxation, Transfer Pricing, FEMA, and GST advisory with 
              extensive practical experience in implementation and dispute resolution.
            </p>

            <Card className="p-6 bg-slate-50 border-none">
              <h3 className="text-xl font-bold text-slate-800 mb-4">Technical Expertise</h3>
              <div className="grid grid-cols-1 gap-3">
                {technicalSkills.map((skill, index) => (
                  <div key={index} className="flex items-start">
                    <CheckCircle2 className="w-5 h-5 text-amber-600 mr-3 mt-0.5 flex-shrink-0" />
                    <span className="text-gray-700">{skill}</span>
                  </div>
                ))}
              </div>
            </Card>

            <div className="pt-4">
              <p className="text-lg text-gray-700 leading-relaxed">
                As a faculty for GST training programmes, I conduct sessions for ICAI members focusing on 
                practical interpretation of GST law, audit and investigation issues, cross-border GST matters, 
                and recent judicial developments.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;